"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var size_chart_1 = require("../../shared/models/size_chart");
var lodash_findindex_1 = __importDefault(require("lodash.findindex"));
var measurements_gql_1 = require("../state/measurements.gql");
var large_measurements_1 = require("../../shared/util/large_measurements");
var anyWindow = window;
var SizeChartComponent = /** @class */ (function (_super) {
    __extends(SizeChartComponent, _super);
    function SizeChartComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.renderTables = function (graphics, sizingChart, displayUnit, optionLabels, labelsToOptions, optionsToVariantId, selectedOptions, topLevelOptionIndex) {
            var hasOptions = optionLabels.length > 0;
            // ensure there is more than one variant
            var variantOptionCombos = Object.keys(optionsToVariantId);
            var hasManyVariants = variantOptionCombos.length > 1;
            var topLevelOptions = sizingChart.topLevelOptionLabel
                && labelsToOptions[sizingChart.topLevelOptionLabel]
                || [];
            var hasTopLevelOptions = topLevelOptions.length > 0;
            var displayTopLevelTitles = hasTopLevelOptions
                && topLevelOptionIndex >= 0
                && hasManyVariants;
            var measurementUnit = sizingChart.unit;
            if (hasOptions && displayTopLevelTitles) {
                var measurementsAsMap = size_chart_1.measurementsToMap(sizingChart.measurements);
                return _this.renderMeasurementTable(topLevelOptions, topLevelOptionIndex, selectedOptions, optionsToVariantId, measurementsAsMap, graphics.dimensionOrder, measurementUnit, displayUnit, large_measurements_1.shouldShowMM(sizingChart));
            }
            else if (hasOptions) {
                var measurementsAsMap = size_chart_1.measurementsToMap(sizingChart.measurements);
                var hash = measurements_gql_1.optionsHash(selectedOptions);
                var currentVariantId = optionsToVariantId[hash];
                var measurementAnnotationMap = measurementsAsMap[currentVariantId];
                return _this.renderAnnotationTable(graphics.dimensionOrder, measurementAnnotationMap, measurementUnit, displayUnit, large_measurements_1.shouldShowMM(sizingChart));
            }
            else {
                var measurementAnnotationMap = size_chart_1.measurementAnnotationsToMap(sizingChart.measurements);
                return _this.renderAnnotationTable(graphics.dimensionOrder, measurementAnnotationMap, measurementUnit, displayUnit, large_measurements_1.shouldShowMM(sizingChart));
            }
        };
        _this.renderNoTable = function () {
            return React.createElement("div", { className: "ma-no-table" },
                React.createElement("h3", null, "This variant is unavailable."));
        };
        _this.selectOption = function (index) { return function (ev) {
            var selectedOptions = _this.state.selectedOptions;
            var optionSelected = ev.currentTarget.value;
            var newOptions = selectedOptions.slice();
            newOptions[index] = optionSelected || newOptions[index];
            _this.setState({ selectedOptions: newOptions });
        }; };
        _this.maybeRenderDropdowns = function (optionLabels, labelsToOptions, selectedOptions, topLevelOptionIndex, availableOptionLabels) {
            var dropdowns = optionLabels.map(function (optionLabel, labelIndex) {
                var optionAvailable = availableOptionLabels.indexOf(optionLabel) >= 0;
                var notTopLevel = labelIndex !== topLevelOptionIndex;
                if (notTopLevel && optionAvailable) {
                    var options = labelsToOptions[optionLabel] || [];
                    var optionsHTML = options.map(function (option) {
                        return React.createElement("option", { value: option, key: option }, option);
                    });
                    var currentOption = selectedOptions[labelIndex];
                    var currentOptionLabel = optionLabels[labelIndex];
                    return React.createElement("div", { className: "ma-dropdown-wrapper", key: optionLabel },
                        React.createElement("div", { className: "ma-select-label" }, currentOptionLabel),
                        React.createElement("div", { className: "ma-select-wrapper" },
                            React.createElement("select", { value: currentOption, onChange: _this.selectOption(labelIndex) }, optionsHTML)));
                }
            });
            return React.createElement("div", { className: "ma-select-group" }, dropdowns);
        };
        _this.renderMeasurementTable = function (topLevelOptions, topLevelOptionIndex, selectedOptionsWithTopLevel, optionsToVariantId, measurementsAsMap, dimensions, measurementUnit, displayUnit, showMM) {
            var topLevelTables = topLevelOptions.map(function (topLevelOption) {
                // get hash of current loop iteration
                var options = selectedOptionsWithTopLevel.slice();
                options[topLevelOptionIndex] = topLevelOption;
                var hash = measurements_gql_1.optionsHash(options);
                var currentVariantId = optionsToVariantId[hash];
                var annotationMeasurements = measurementsAsMap[currentVariantId];
                var annotationTableHTML;
                if (annotationMeasurements) {
                    annotationTableHTML = React.createElement("div", { key: hash },
                        React.createElement("h2", { className: "ma-top-level" }, topLevelOption),
                        _this.renderAnnotationTable(dimensions, annotationMeasurements, measurementUnit, displayUnit, showMM));
                }
                return annotationTableHTML ? React.createElement("div", { key: hash }, annotationTableHTML) : null;
            });
            var finalTopLevelTables = topLevelTables.filter(function (topLevelTable) { return topLevelTable; });
            if (finalTopLevelTables.length > 0) {
                return React.createElement("div", null, topLevelTables);
            }
            return null;
        };
        _this.renderAnnotationTable = function (dimensions, annotationMeasurements, measurementUnit, displayUnit, showMM) {
            if (annotationMeasurements) {
                var tableHTML = dimensions
                    .filter(function (d) { return d.showInSizeChart; })
                    .map(function (dimension) {
                    var measurement = annotationMeasurements[dimension.uniqueKey];
                    var contents;
                    if (measurement) {
                        var nameKey = "name-" + dimension.id;
                        var measurementKey = "measure-" + dimension.id;
                        contents = [
                            React.createElement("div", { className: "ma-annotation-attribute ma-annotation-name", key: nameKey }, dimension.name),
                            React.createElement("div", { className: "ma-annotation-attribute ma-annotation-measurement", key: measurementKey }, size_chart_1.displayMeasurement(measurement, measurementUnit, displayUnit, showMM)),
                        ];
                    }
                    return contents ? React.createElement("div", { className: "ma-sizechart-entry", key: dimension.id }, contents) : null;
                });
                var finalTableHTML = tableHTML.filter(function (html) { return html; });
                if (finalTableHTML.length > 0) {
                    return React.createElement("div", { className: "ma-sizechart-table" }, finalTableHTML);
                }
            }
            return null;
        };
        _this.toggleDisplayUnit = function (ev) {
            ev.preventDefault();
            _this.props.toggleDisplayUnit();
        };
        _this.hideSizeChart = function (ev) {
            ev.preventDefault();
            _this.props.hideSizeChartFn();
        };
        var topLevelOptionIndex = -1;
        var topLevelOptionLabel = props.sizeChart.topLevelOptionLabel;
        if (topLevelOptionLabel) {
            var index = lodash_findindex_1.default(props.optionLabels, function (label) { return label === topLevelOptionLabel; });
            if (index >= 0) {
                topLevelOptionIndex = index;
            }
        }
        var selectedOptions = props.defaultOptions;
        _this.state = { selectedOptions: selectedOptions, topLevelOptionIndex: topLevelOptionIndex };
        return _this;
    }
    SizeChartComponent.prototype.render = function () {
        var _a = this, hideSizeChart = _a.hideSizeChart, toggleDisplayUnit = _a.toggleDisplayUnit;
        var _b = this.state, selectedOptions = _b.selectedOptions, topLevelOptionIndex = _b.topLevelOptionIndex;
        var _c = this.props, displayUnit = _c.displayUnit, sizeChart = _c.sizeChart, optionLabels = _c.optionLabels, labelsToOptions = _c.labelsToOptions, optionsToVariantId = _c.optionsToVariantId, graphics = _c.graphics, maxHeight = _c.maxHeight;
        var tableHTML = this.renderTables(graphics, sizeChart, displayUnit, optionLabels, labelsToOptions, optionsToVariantId, selectedOptions, topLevelOptionIndex);
        var emptyTable = this.renderNoTable();
        var dropDownHTML = this.maybeRenderDropdowns(optionLabels, labelsToOptions, selectedOptions, topLevelOptionIndex, sizeChart.availableOptionLabels);
        var sizingHeaderCopy = anyWindow
            && anyWindow.measuredApp
            && anyWindow.measuredApp.sizingHeaderCopy
            || "Sizing";
        return React.createElement("div", { className: "ma-size-chart" },
            React.createElement("div", { className: "ma-head" },
                React.createElement("h1", null, sizingHeaderCopy),
                React.createElement("div", { className: "ma-action-button-group" },
                    React.createElement("a", { className: "ma-size-unit ma-action-button", href: "#", onClick: toggleDisplayUnit }, "in / cm"),
                    React.createElement("a", { className: "ma-size-chart-cancel ma-action-button", href: "#", onClick: hideSizeChart },
                        React.createElement("i", { className: "fas fa-times" })))),
            React.createElement("div", { className: "ma-sub" }, dropDownHTML),
            React.createElement("div", { className: "ma-body", style: maxHeight ? { maxHeight: maxHeight } : undefined }, tableHTML ? tableHTML : emptyTable));
    };
    return SizeChartComponent;
}(React.PureComponent));
exports.default = SizeChartComponent;
